export default __webpack_public_path__ + "static/media/logo-info.0b322325.svg";